import React from 'react';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import Base from '../Base';

const useStyles = makeStyles(() => ({
  bold: {
    fontWeight: 800,
  },
}))


function ShootoutShotSavedEvent({event, teams, players, periods}) {
  const classes = useStyles();
  const shooter = players[event.player];
  const team = teams[shooter.team].id;
  const goalie = players[event.result.player];
  
  return (
    <Base
      team={team}
      type="Shootout Saved"
    >
      <Typography variant="body2">
        Shootout attempt by{' '}
        <span className={classes.bold}>{shooter.name}</span>
        {' '}has been saved by{' '}
        <span className={classes.bold}>{goalie.name}</span>
        .
      </Typography>
    </Base>
  )
}

export default ShootoutShotSavedEvent;
